import axios from 'axios'
import endpoint from '@/config/api.endpoints'

axios.defaults.withCredentials = true
axios.defaults.baseURL = endpoint.host
axios.defaults.headers.common['Accept'] = 'application/json'

export default axios
